import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { CATEGORIES } from "../lib/data";

const CONTACT_PHONE = "9467458749";
const CONTACT_WHATSAPP = "https://wa.me/919467458749";
const CONTACT_EMAIL = "sales@thepataudi.com";

export default function Footer() {
  return (
    <footer className="bg-primary text-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.jpeg" alt="The Pataudi" className="h-11 w-11 rounded-full object-cover ring-1 ring-white/20 bg-black" loading="lazy" />
            <span className="font-display font-bold text-lg">The Pataudi</span>
          </div>
          <p className="text-white/70 text-sm">Find. Connect. Done.</p>
          <p className="text-white/50 text-xs mt-3">Properties, vehicles, healthcare, education, food & more across Gurugram, Pataudi and nearby areas.</p>
        </div>

        <div>
          <h3 className="font-display font-semibold text-sm mb-3">Categories</h3>
          <ul className="space-y-2">
            {CATEGORIES.slice(0, 6).map((c) => (
              <li key={c.id}>
                <Link to={`/listings/${c.id}`} className="text-white/70 hover:text-white text-sm transition-colors">{c.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display font-semibold text-sm mb-3">More</h3>
          <ul className="space-y-2">
            {CATEGORIES.slice(6).map((c) => (
              <li key={c.id}>
                <Link to={`/listings/${c.id}`} className="text-white/70 hover:text-white text-sm transition-colors">{c.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display font-semibold text-sm mb-3">Company</h3>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact</Link></li>
            <li><Link to="/safety-tips" className="hover:text-white" data-testid="footer-safety-link">Safety Tips</Link></li>
            <li><Link to="/pricing" className="hover:text-white" data-testid="footer-pricing-link">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display font-semibold text-sm mb-3">Legal</h3>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms</Link></li>
            <li><Link to="/refund" className="hover:text-white" data-testid="footer-refund-link">Refund Policy</Link></li>
            <li><Link to="/cancellation" className="hover:text-white" data-testid="footer-cancellation-link">Cancellation Policy</Link></li>
            <li><Link to="/payment-policy" className="hover:text-white" data-testid="footer-payment-policy-link">Payment Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-white" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
          </ul>
        </div>

        <div id="contact-us" data-testid="footer-contact-us" className="col-span-2 md:col-span-1">
          <h3 className="font-display font-semibold text-sm mb-3">Contact Us</h3>
          <a
            href={`tel:${CONTACT_PHONE}`}
            data-testid="footer-phone-link"
            className="flex items-center gap-2 text-sm text-white/90 hover:text-white mb-2"
          >
            <Phone className="h-4 w-4 text-accent" />
            <span className="font-medium">+91 {CONTACT_PHONE}</span>
          </a>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="flex items-center gap-2 text-sm text-white/90 hover:text-white mb-3 break-all"
          >
            <Mail className="h-4 w-4 text-accent shrink-0" />
            <span>{CONTACT_EMAIL}</span>
          </a>
          <div className="flex flex-col gap-2">
            <a
              href={`tel:${CONTACT_PHONE}`}
              data-testid="footer-call-link"
              className="inline-flex items-center justify-center gap-2 h-9 rounded-sm border border-white/20 text-white hover:bg-white/10 text-xs font-medium transition-colors"
            >
              <Phone className="h-3.5 w-3.5" /> Call Now
            </a>
            <a
              href={CONTACT_WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center justify-center gap-2 h-9 rounded-sm bg-[#25D366] hover:bg-[#1ebe5d] text-white text-xs font-medium transition-colors"
            >
              <MessageCircle className="h-3.5 w-3.5" /> Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 text-center text-white/50 text-xs">
          © 2025 The Pataudi. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
